import { GridValidRowModel } from '@mui/x-data-grid-pro'
import cn from 'classnames'
import React from 'react'
import TextAndPillCell, {
  TextAndPillCellProps,
} from 'src/components/DataGrid/cells/TextAndPillCell/TextAndPillCell'

import styles from './CardGraphicAndNameCell.style'

type CardGraphicAndNameCellProps<Row extends GridValidRowModel> = {
  cardTypeImageSrc: string
  cardTypeAlt: string
  last4?: string
  shadow?: boolean
  size?: 'medium' | 'large'
} & Omit<TextAndPillCellProps<Row>, 'icon' | 'pillText'>

const CardGraphicAndNameCell = <Row extends GridValidRowModel>(
  props: CardGraphicAndNameCellProps<Row>,
) => {
  const {
    cardTypeImageSrc,
    cardTypeAlt,
    last4,
    shadow,
    className,
    size = 'medium',
    ...cellProps
  } = props
  return (
    <TextAndPillCell
      css={styles}
      className={className}
      icon={
        <img
          className={cn(size, { shadow })}
          src={cardTypeImageSrc}
          alt={cardTypeAlt}
        />
      }
      pillText={last4 ?? ''}
      {...cellProps}
    />
  )
}

export default CardGraphicAndNameCell
